<template>
  <main-layout
    class="uplinkDataSheet"
    page-title="上链数据表"
    custom-back
    @listen-back="goBack"
  >
    <div slot="main-content" class="main-content">
      <!-- 页面头部 -->
      <!-- <div class="query-form">
        <div class="aviatFarming-form-div aviatFarming-form-date">
          <el-date-picker
            v-model="date"
            size="medium"
            type="daterange"
            :clearable="false"
            :picker-options="pickerDateOptions"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
      </div> -->
      <div class="uplink-num">
        总上链条数：<span>{{ formatNumberWithCommas(total) }}</span
        >条
      </div>
      <div class="uplink-list">
        <div
          class="uplink-item"
          v-for="(item, index) in uplinkData"
          :key="index"
        >
          <div class="uplink-item-title">{{ item.name }}</div>
          <div class="uplink-item-box">
            <div class="uplink-item-data">
              <div class="uplink-item-data-label">上链总数（条）：</div>
              <div class="uplink-item-data-value">{{ item.total }}</div>
            </div>
            <div class="uplink-item-data">
              <div class="uplink-item-data-label">本日上链数量（条）：</div>
              <div class="uplink-item-data-value">{{ item.dailyVolume }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/MainLayout";
import { getStorage } from "@/utils/storage";
import { getDataUplinkList } from "@/api/request/snkd.produce";

export default {
  name: "UplinkDataSheet",
  components: {
    MainLayout,
  },
  data() {
    return {
      date: [],
      total: 0,
      info: getStorage("FARMINFO"),
      uplinkData: [
        {
          name: "采收信息",
          key: "pickRecordAgriculture",
        },
        {
          name: "生产档案信息",
          key: "plantPlanAgriculture",
        },
        {
          name: "种源信息",
          key: "productInfo",
        },
        {
          name: "农事信息",
          key: "mission",
        },
        {
          name: "销售信息",
          key: "agriculturalProductsSell",
        },
        {
          name: "合格证信息",
          key: "certificate",
        },
      ],
      pickerDateOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  mounted() {
    //初始化时间
    // const today = new Date();
    // const thirtyDaysAgo = new Date(today);
    // thirtyDaysAgo.setDate(today.getDate() - 29);
    // let startDate = thirtyDaysAgo.format("yyyy-MM-dd");
    // let endDate = new Date().format("yyyy-MM-dd");
    // this.date = [startDate, endDate];
    this.getDataUplinkList();
  },
  methods: {
    async getDataUplinkList() {
      try {
        const { farmId } = this.info;
        await getDataUplinkList({
          farmId: farmId,
        }).then((res) => {
          const { respCode, obj } = res;
          if (respCode === 0) {
            this.total = obj.amount;
            this.uplinkData = this.uplinkData.map((item) => {
              return {
                ...item,
                total: obj[item.key + "Count"],
                dailyVolume: obj[item.key + "NowCount"],
              };
            });
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
    // 返回上一页
    goBack() {
      window.history.go(-1);
    },
    formatNumberWithCommas(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>

<style scoped lang="scss">
.uplinkDataSheet {
  .main-content {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    padding: 30px 24px;
    box-sizing: border-box;
    background: #ffffff;
    .uplink-num {
      margin: 0 0 24px;
      height: 72px;
      border-radius: 20px;
      box-shadow: 0px 5px 20px 0px rgba(85, 85, 124, 0.13);
      color: #333;
      font-size: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        display: inline-block;
        color: #64c3a4;
        font-size: 24px;
        font-weight: 700;
        padding-right: 4px;
      }
    }
    .uplink-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      .uplink-item {
        margin-right: 20px;
        width: calc((100% - 60px) / 4);
        height: 160px;
        border-radius: 20px;
        box-shadow: 0px 5px 20px 0px rgba(85, 85, 124, 0.13);
        padding: 20px;
        box-sizing: border-box;
        margin-bottom: 28px;
        &-title {
          color: #333;
          font-size: 20px;
          font-weight: 700;
          margin-bottom: 33px;
        }
        &-box {
          .uplink-item-data {
            display: flex;
            justify-content: space-between;
            color: #888;
            font-size: 14px;
            margin-bottom: 26px;
            &-value {
              color: #64c3a4;
            }
          }
        }
      }
      .uplink-item:nth-of-type(4n + 0) {
        margin-right: 0;
      }
    }
  }
}
</style>
